import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

type TextFieldWithButtonLabelProps = TextFieldProps & { label: string };

export const TextFieldWithButtonLabel = ({
    label,
    ...props
}: TextFieldWithButtonLabelProps) => (
    <TextField
        size="small"
        fullWidth
        {...props}
        InputProps={{
            endAdornment: (
                <AppButton
                    variant="outlined"
                    disabled
                    sx={{
                        "bgcolor": "action.selected",
                        "marginRight": "-14px",
                        "borderRadius": "0 .25rem .25rem 0",
                        ":disabled": {
                            color: "text.primary",
                        }
                    }}
                >
                    {label}
                </AppButton>
            ),
        }}
    />
);
